import { type FieldValues, type UseControllerProps, useFormContext } from 'react-hook-form';

import { Checkbox, type CheckboxProps } from '@wf/components';

import { type LicenseFieldProps } from './LicenseFieldController';

import { useLicenseController } from '../../hooks/useLicenseController';

export const LicenseCheckbox = ({
  name,
  defaultValue,
  configName,
  featureFlag,
  rules,
  shouldUnregister,
  control,
  viewMode,
  disabled,
  ...rest
}: CheckboxProps & LicenseFieldProps & UseControllerProps<FieldValues, any> & { viewMode?: boolean }) => {
  const { control: contextControl } = useFormContext();

  const {
    field: { value, onChange, ...fieldRest },
    computedProps,
    config,
  } = useLicenseController({
    name,
    configName,
    featureFlag,
    control: control ?? contextControl,
    defaultValue: defaultValue ?? false,
    rules,
    shouldUnregister,
    isCheckBox: true,
    disabled,
  });

  const handleChange: typeof rest.onChange = (...args) => {
    onChange(...args);

    if ('onChange' in rest && typeof rest.onChange === 'function') {
      rest.onChange(...args);
    }
  };

  if (config.isHidden) {
    return <></>;
  }

  return (
    <Checkbox
      {...fieldRest}
      {...computedProps}
      {...rest}
      disabled={computedProps.disabled ?? viewMode}
      checked={computedProps.value}
      onChange={handleChange}
    />
  );
};
